if (!customElements.get('component-accordion')) {
  customElements.define('component-accordion', class Accordion extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      // Store the <details> element
      this.details = this.querySelector('details');
      // Store the <summary> element
      this.summary = this.querySelector('summary');
      // Store the <div class="content"> element
      this.content = this.querySelector('.accordion__content, [data-content]') || this.summary.nextElementSibling;

      // Store the animation object (so we can cancel it if needed)
      this.animation = null;
      // Store if the element is closing
      this.isClosing = false;
      // Store if the element is expanding
      this.isExpanding = false;
      // Detect user clicks on the summary element
      this.onClick = this.onClick.bind(this);
      this.summary.addEventListener('click', this.onClick);
      this.addEventListener('focus', this.onFocus);
    }

    reset() {
      this.summary.removeEventListener('click', this.onClick);
      this.init();
    }

    onFocus() {
      if (this.isExpanding || this.details.hasAttribute('open')) return;
      this.summary.click();
    }

    onClick(event) {
      // Stop default behaviour from the browser
      event.preventDefault();
      // Add an overflow on the <details> to avoid content overflowing
      this.details.style.overflow = 'hidden';
      // Check if the element is being closed or is already closed
      if (this.isClosing || !this.details.open) {
        this.open();
        // Check if the element is being openned or is already open
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }

    shrink() {
      // Set the element as "being closed"
      this.isClosing = true;

      // Store the current height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the height of the summary
      let endHeight = `${this.summary.offsetHeight}px`;
      if (window.getComputedStyle(this.summary).position === 'absolute') {
        endHeight = '0px';
      }

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });

      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(false);
      // If the animation is cancelled, isClosing variable is set to false
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      // Apply a fixed height on the element
      this.details.style.height = `${this.details.offsetHeight}px`;
      // Force the [open] attribute on the details element
      this.details.open = true;
      // Wait for the next frame to call the expand function
      window.requestAnimationFrame(this.expand.bind(this));
    }

    expand() {
      // Set the element as "being expanding"
      this.isExpanding = true;
      // Get the current fixed height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the open height of the element (summary height + content height)
      let endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
      if (window.getComputedStyle(this.summary).position === 'absolute') {
        endHeight = `${this.content.offsetHeight}px`;
      }

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(true);
      // If the animation is cancelled, isExpanding variable is set to false
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      // Set the open attribute based on the parameter
      this.details.open = open;
      // Clear the stored animation
      this.animation = null;
      // Reset isClosing & isExpanding
      this.isClosing = false;
      this.isExpanding = false;
      // Remove the overflow hidden and the fixed height
      this.details.style.height = this.details.style.overflow = '';
    }
  });
}